import React from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { UnitSelect } from '../inputs/unit-select';
import { OptionOrOptions } from '../option';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type UnitSelectProps = React.ComponentProps<typeof UnitSelect>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    unitSelectProps: UnitSelectProps;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormUnitSelect<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { unitSelectProps, ...integratedFormControlProps } = props;
    const renderViewMode = React.useCallback((value: OptionOrOptions) => {
        if (Array.isArray(value)) {
            if (value.length === 0) return '--';
            return value.map((option) => option.label).join(', ');
        }
        return value.label;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => <UnitSelect {...inputProps} {...unitSelectProps} />}
        </IntegratedFormControl>
    );
}
